import trellisLightTheme from './trellis/light/theme';
import trellisDarkTheme from './trellis/dark/theme';
import canvasLightTheme from './canvas/light/theme';
import warmNeutralLightTheme from './warm-neutral/light/theme';
import navyLightTheme from './navy/light/theme';
import lavenderLightTheme from './lavender/light/theme';

export default {
  ['canvas-light']: canvasLightTheme,
  ['trellis-light']: trellisLightTheme,
  ['trellis-dark']: trellisDarkTheme,
  ['warm-neutral-light']: warmNeutralLightTheme,
  ['navy-light']: navyLightTheme,
  ['lavender-light']: lavenderLightTheme,
};
